import { css } from "react-emotion";
import * as bp from "./layout/breakpoints";
// This file exports class names which can be composed in other components
// Potentially dangerous but probably not critical:
// These classes get injected before they're actually rendered
// -> Web fonts are always loaded
// MS ratio 1.618
export const helvetica = css `
  font-family: "HelveticaNeueLTW01", "Helvetica Neue", Helvetica, sans-serif;
  font-weight: 400;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
`;
export const helveticaLight = css `
  font-family: "HelveticaNeueLTW01", "Helvetica Neue", Helvetica, sans-serif;
  font-weight: 300;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
`;
export const helveticaBold = css `
  font-family: "HelveticaNeueLTW01", "Helvetica Neue", Helvetica, sans-serif;
  font-weight: 700;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
`;
export const helveticaItalic = css `
  font-family: "HelveticaNeueLTW01", "Helvetica Neue", Helvetica, sans-serif;
  font-weight: 400;
  font-style: italic;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
`;
export const h1 = css `
  ${helveticaLight};
  font-size: 1.875rem;
  line-height: 1.4;
  ${bp.medium `
    font-size: 2.1875rem;
  `};
`;
export const h2 = css `
  ${helveticaLight};
  font-size: 1.625rem;
  line-height: 1.4;
  ${bp.medium `
    font-size: 1.6875rem;
  `};
`;
export const h3 = css `
  ${helveticaBold};
  font-size: 1rem;
  line-height: 1.6875;
  ${bp.medium `
    font-size: 1.0625rem;
  `};
`;
export const h4 = css `
  ${helveticaBold};
  font-size: 0.875rem;
  line-height: 1.571;
`;
export const paragraph = css `
  ${helvetica};
  font-size: 1rem;
  line-height: 1.6875;
  ${bp.medium `
    font-size: 1.0625rem;
  `};
`;
export const strong = css `
  ${helveticaBold};
`;
export const italic = css `
  ${helveticaItalic};
`;
export const small = css `
  ${helvetica};
  font-size: 0.875rem;
  line-height: 1.571;
`;



// WEBPACK FOOTER //
// ./src/theme/typefaces.ts